// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ellipsis-key[data-v-2fab18cf] {\n  width: calc(100% - 25px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
